import { NsCard } from 'components/common/ns-card/NsCard';
import { NsContent } from 'components/common/ns-content/NsContent';
import { NsDescriptionList } from 'components/common/ns-description-list/NsDescriptionList';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';

import { useNavigation } from 'hooks/useNavigation';
import { useOrderSummary } from 'components/direct-sales/order-summary/hooks/useOrderSummary';
import { useMaskPII } from 'hooks/useMaskPII';
import { maskPartialData } from 'utils/misc';

import { formatDate } from 'components/direct-sales/quote/utils';

export const OrderSummaryPaymentDetails = () => {
  const { mask } = useMaskPII();
  const { eventTypes, next } = useNavigation();
  const {
    firstPaymentDate,
    formatedPaymentDay,
    paymentName,
    isAnyDirectDebit,
    directDebitDetails,
    supplyAddress
  } = useOrderSummary();

  const changePaymentDetails = () => {
    next({ eventType: eventTypes.CHANGE_PAYMENT_DETAILS, wasVisited: true });
  };

  return (
    <>
      <NsContent spacing="normal">
        <h2 className="h4">Payment details</h2>
      </NsContent>

      <NsCard>
        <NsDescriptionList>
          {isAnyDirectDebit
            ? [
                {
                  term: 'Account holder details',
                  description: [
                    <>
                      <p {...mask}>
                        {directDebitDetails.firstName}{' '}
                        {directDebitDetails.lastName},
                      </p>
                      <p {...mask}>
                        {maskPartialData(directDebitDetails.accountNumber)},
                      </p>
                      <p {...mask}>{directDebitDetails.sortCode},</p>
                      <p {...mask}>
                        {formatDate(directDebitDetails.birthDate)}
                      </p>
                    </>
                  ]
                },
                {
                  term: 'Payment date',
                  description: <>{formatedPaymentDay} of every month</>
                },
                {
                  term: 'Payment method',
                  description: [
                    <>{paymentName}</>,
                    <>Your first payment will be</>,
                    <>{formatDate(firstPaymentDate, 'DD/MM/YY')}</>
                  ]
                },
                {
                  term: 'Billing address',
                  description: [
                    <>
                      {directDebitDetails.isCommercial && (
                        <p {...mask}>{directDebitDetails.companyName}</p>
                      )}
                      <p {...mask}>
                        {directDebitDetails.address?.displayName}
                        {', '}
                        {directDebitDetails.address?.postcode}
                      </p>
                      {directDebitDetails.isCommercial && (
                        <p {...mask}>
                          Company Reg Number:{' '}
                          {directDebitDetails.companyRegistrationNumber}
                        </p>
                      )}
                    </>,
                    <>
                      <br />
                      <NsSecondaryCta onClick={changePaymentDetails} icon="">
                        Edit payment details
                      </NsSecondaryCta>
                    </>
                  ]
                }
              ]
            : [
                {
                  term: 'Payment method',
                  description: paymentName
                },
                {
                  term: 'Billing address',
                  description: (
                    <p {...mask}>
                      {supplyAddress?.displayName}
                      {', '}
                      {supplyAddress?.postcode}
                    </p>
                  )
                }
              ]}
        </NsDescriptionList>
      </NsCard>
    </>
  );
};

export default OrderSummaryPaymentDetails;
